import {
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TableRow,
} from "@material-ui/core"
import { PencilIcon, TrashIcon } from "App/Assets"
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooter,
  ModalDeleteConfirm,
} from "App/Component/ui"
import { instance4, instance5 } from "App/constants"
import { useDatatables } from "App/hooks"
import {
  convertToValidPrice,
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
  getLocalName,
  isNull,
  today,
} from "App/utils/helpers"
import React, { useState, useContext } from "react"
import { stableSort, getComparator } from "App/Component/ui/datatable/utils"
import { FormContext } from "./context/FormContext"
import { requiredMsg } from "App/utils/validation"
// import { accessCode } from "utils/all";
import { LIST_URL_WAREHOUSE } from "utils/warehouse"
import { FreezeTableClient } from "components/organism"

export const urlCreatePembelian = LIST_URL_WAREHOUSE.pembelianPBF.add
export const urlUpdatePembelian = LIST_URL_WAREHOUSE.pembelianPBF.update
export const urlAcceptPembelian = LIST_URL_WAREHOUSE.pembelianPBF.accept

export const urlGetPembelianById = LIST_URL_WAREHOUSE.pembelianPBF.getById

export const urlGetPembelianItemByPembelianId =
  LIST_URL_WAREHOUSE.pembelianPBF.getItemById

export const urlCreateBarang = LIST_URL_WAREHOUSE.pembelianPBF.addBarang
export const urlUpdateBarang = LIST_URL_WAREHOUSE.pembelianPBF.updateBarang
export const urlDeleteBarang = LIST_URL_WAREHOUSE.pembelianPBF.deleteBarang

export const urlGetGudang = LIST_URL_WAREHOUSE.masterGudangPBF.getGudang

export const STATUS_OPEN_DRAFT_PEMBELIAN = 0

// TUTUP belum masuk ke inventory
export const STATUS_PROSES_PEMBELIAN = 1

// ACCEPT masuk ke inventory
export const STATUS_SELESAI_PEMBELIAN = 2

export const FORM_RESET_STATE_WMS_PEMBELIAN = {
  id: "",
  idgl: null,
  date: today(true),

  is_po: false,
  po_id: "",
  po_label: "Cari PO",

  gudang_id: null,
  gudang: "Pilih Gudang",

  user: getLocalName(),

  supplier_id: null,
  supplier: "Pilih Supplier",

  faktur_no: "",
  faktur_tgl: today(),

  jatuhtempo_tgl: today(),
  kedatangan_tgl: today(),
  tagih_tgl: today(),
  kasbank_id: null,
  kasbank: "Pilih Kas Bank",

  isOpenDraft: false,
  isProcess: false,

  status: STATUS_OPEN_DRAFT_PEMBELIAN,

  biayalain: 0,
  biayalain2: 0,

  ongkos: 0,
  ongkos2: 0,

  potongan: 0,
  potongan2: 0,

  tax: 0,
  tax2: 0,

  sisa: 0,
  is_changesellprice: false,
  bayar: 0,

  type: "create",

  jumlah: 0,
  pembayaran: 0,

  sub_disc: 0,
  sub_total: 0,
  sub_total2: 0,

  total: 0,
  total_jumlah: 0,

  is_persentase_potongan: false,
}

export const getPembelianById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetPembelianById}/${id}`)
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data:
          res.data.length > 0
            ? res.data[0]
            : {
                biayalain: 0,
                ongkos: 0,
                potongan: 0,
                tax: 0,
                bayar: 0,
                sisa: 0,
              },
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}
export const getIDGLById = async (idgl) => {
  try {
    const api = await instance5.get(
      `/ts/transaksi/get-transaksi-by-gl?idgl=${idgl}`,
    )
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getPembelianItemByPembelianId = async (id) => {
  try {
    const api = await instance4.get(`${urlGetPembelianItemByPembelianId}/${id}`)
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const deletePembelianListById = async (id) => {
  try {
    const api = await instance4.post(urlDeleteBarang, {
      id,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res,
        message: "Berhasil menghapus pembelian list",
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    }
  }
}

export const exportItemPembelianFarmasi = async (id_pembelian) => {
  try {
    const api = await instance4.get(
      `/wmsfarmasi/pembelianItem/listItemByPembelianIdExport/${id_pembelian}`,
    )
    const res = api.data
    return {
      state: true,
      data: res.data,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}


export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "namaBarang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nobatch",
    disablePadding: false,
    label: "NO BATCH",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "expdate",
    disablePadding: false,
    label: "TANGGAL EXP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "item_pembelian",
    disablePadding: false,
    label: "ITEM PEMBELIAN",
    align: "center",
    minWidth: "600px",
    rowSpan: 1,
    colSpan: 8,
    child: [
      {
        id: "satuan_beli",
        disablePadding: false,
        label: "SATUAN BELI",
        align: "left",
        minWidth: "200px",
      },
      {
        id: "harga_satuan",
        disablePadding: false,
        label: "HARGA BELI",
        align: "left",
      },
      {
        id: "qty",
        disablePadding: false,
        label: "QTY BELI",
        align: "left",
      },
      {
        id: "qjb",
        disablePadding: false,
        label: "QJB",
        align: "left",
      },
      {
        id: "disc",
        disablePadding: false,
        label: "DISC (%)",
        align: "left",
        minWidth: "150px",
      },
      {
        id: "nilai_disc",
        disablePadding: false,
        label: "NILAI DISC",
        align: "left",
        minWidth: "150px",
      },
      {
        id: "tax",
        disablePadding: false,
        label: "TAX (%)",
        align: "left",
        minWidth: "150px",
      },
      {
        id: "nilai_tax",
        disablePadding: false,
        label: "NILAI TAX",
        align: "left",
        minWidth: "150px",
      },
    ],
  },
  {
    id: "akumulasi_item_pembelian",
    disablePadding: false,
    label: "AKUMULASI ITEM PEMBELIAN",
    align: "center",
    minWidth: "400px",
    rowSpan: 1,
    colSpan: 3,
    child: [
      {
        id: "satuan_jual",
        disablePadding: false,
        label: "SATUAN JUAL",
        align: "left",
        minWidth: "150px",
      },

      {
        id: "qty_total",
        disablePadding: false,
        label: "QTY TOTAL",
        align: "left",
        minWidth: "150px",
      },
      {
        id: "qjbhpp",
        disablePadding: false,
        label: "HARGA QJB HPP",
        align: "left",
        minWidth: "150px",
      },
    ],
  },
  {
    id: "total",
    disablePadding: false,
    label: "TOTAL",
    align: "center",
    minWidth: "400px",
    rowSpan: 1,
    colSpan: 3,
    child: [
      {
        id: "totalDisc",
        disablePadding: false,
        label: "TOTAL DISC",
        align: "left",
        minWidth: "150px",
      },
      {
        id: "totalTax",
        disablePadding: false,
        label: "TOTAL TAX",
        align: "left",
        minWidth: "150px",
      },
      {
        id: "jumlah",
        disablePadding: false,
        label: "JUMLAH/PERSEDIAAN MEDIS",
        align: "left",
        minWidth: "200px",
      },
    ],
  },
]

export const RenderListPembelian = ({
  classes,
  listPembelian,
  formBarang,
  setFormBarang,
  showModalBarang,
  setShowModalBarang,
  setNewDataPembelianList,
}) => {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listPembelian,
    orderByDefault: "namaBarang",
    orderByRow: ["namaBarang"],
  })

  const { formData } = useContext(FormContext)

  async function deleteList() {
    const res = await deletePembelianListById(formBarang.id)
    if (res.state) {
      defaultToastSuccess(res?.message)
      await setNewDataPembelianList(formData.id)
      setShowModalDeleteConfirm(false)
    } else {
      defaultToastSuccess(res?.message)
    }
  }

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
    setFormBarang({
      ...formBarang,
      id: row?.id,
    })
  }

  const handleClickUpdate = (row) => {
    setFormBarang({
      barang: row?.namaBarang,
      id: row?.id,
      pembelian_id: row?.pembelian_id,
      barang_id: row?.barang_id,
      satuan_nama: row?.namaSatuan_beli,
      satuan_id: row?.satuan_id,
      satuanjual_nama: row?.namaSatuan_jual,
      satuanjual_id: row?.satuanjual_id,
      harga2: formatNumber(row?.harga_satuan),
      harga: row?.harga_satuan,
      qty: formatNumber(row?.qty),
      disc: formatNumber(row?.disc),
      nilai_disc: formatNumber(row?.nilai_disc),
      tax: formatNumber(row?.tax),
      nilai_tax: formatNumber(row?.nilai_tax),
      qjb: formatNumber(row?.qjb),
      hargaqjbhpp: formatRupiah(row.hargaqjbhpp),
      nobatch: row?.nobatch,
      exired_date: isNull(row.exired_date)
        ? ""
        : defaultDateInputDisplay(row?.exired_date),
      remark: row?.remark,

      po_satuan_id: row?.po_satuan_id,
      po_qty: row?.po_qty,
      po_harga_satuan: formatNumber(row?.po_harga_satuan),
      po_disc: formatNumber(row?.po_disc),
      po_nilai_disc: formatNumber(row?.po_nilai_disc),
    })
    setShowModalBarang(!showModalBarang)
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <FreezeTableClient
        title="Data Transaksi Pembelian"
        setQ={setQ}
        // maxHeight="500px"
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={listPembelian}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        trTopChild="61px"
        headCellsLength={headCells.length + 14}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                // style={{
                //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                // }}
              >
                <TableCell scope="row" padding="none" align="center">
                  {index + 1}
                </TableCell>

                <TableCell scope="row" padding="none" align="center">
                  {formData.status === STATUS_OPEN_DRAFT_PEMBELIAN && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}
                    >
                      <IconButtonDatatable
                        onClick={() => handleClickUpdate(row)}
                      >
                        <PencilIcon />
                      </IconButtonDatatable>

                      {!formData.is_po && (
                        <IconButtonDatatable
                          onClick={() => handleClickDelete(row)}
                        >
                          <TrashIcon />
                        </IconButtonDatatable>
                      )}
                    </div>
                  )}
                </TableCell>

                <RenderTableCell row={row} />
              </TableRow>
            )
          })}
        {/* {listPembelian.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={headCells.length+14}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )} */}
      </FreezeTableClient>
    </>
  )
}

export const RenderTableCell = ({ row }) => {
  const hargas = convertToValidPrice(row?.harga_satuan)
  const qtys = convertToValidPrice(row?.qty)
  const nilaiDisc = ((convertToValidPrice(row?.disc) / 100) * hargas).toFixed(2)
  const nilaiTax = (
    (convertToValidPrice(row?.tax) / 100) *
    (hargas - nilaiDisc)
  ).toFixed(2)
  const subHarga =
    hargas - convertToValidPrice(nilaiDisc) + convertToValidPrice(nilaiTax)
  const subQjb = (subHarga / convertToValidPrice(row?.qjb)).toFixed(2)
  const totalTax = nilaiTax * qtys
  const totalDisc = nilaiDisc * qtys
  const subJumlah = subHarga * qtys

  return (
    <>
      <TableCell align="left">{row.id}</TableCell>
      <TableCell align="left">{row.namaBarang}</TableCell>
      <TableCell align="left">{row.nobatch}</TableCell>
      <TableCell align="left">
        {defaultDateDisplay(row.exired_date, false)}
      </TableCell>
      <TableCell align="left">{row.namaSatuan_beli}</TableCell>
      <TableCell align="right">{formatNumber(row.harga_satuan)}</TableCell>
      <TableCell align="right">{formatNumber(row.qty)}</TableCell>
      <TableCell align="right">{formatNumber(row.qjb)}</TableCell>
      <TableCell align="right">{formatNumber(row.disc)}</TableCell>
      <TableCell align="right">{formatNumber(nilaiDisc)}</TableCell>
      <TableCell align="right">{formatNumber(row.tax)}</TableCell>
      <TableCell align="right">{formatNumber(nilaiTax)}</TableCell>
      <TableCell align="left">{row.namaSatuan_jual}</TableCell>
      <TableCell align="right">{formatNumber(row.qty * row.qjb)}</TableCell>
      <TableCell align="right">{formatNumber(subQjb)}</TableCell>
      <TableCell align="right">{formatNumber(totalDisc)}</TableCell>
      <TableCell align="right">{formatNumber(totalTax)}</TableCell>
      <TableCell align="right">{formatNumber(subJumlah)}</TableCell>
    </>
  )
}

export const validationInputPembelian = (formData) => {
  const errors = {}

  if (isNull(formData.gudang_id)) {
    errors["gudang_id"] = requiredMsg("Gudang")
  }

  if (isNull(formData.supplier_id)) {
    errors["supplier_id"] = requiredMsg("Supplier")
  }

  if (isNull(formData.kasbank_id)) {
    errors["kasbank_id"] = requiredMsg("Kas Bank")
  }

  return errors
}
